import React from "react";
import { InfoIcon } from "../Auth/onboarding/icons";

export default function TestingTipCard() {
  return (
    <p className="install-note asst-tip">
      <InfoIcon />
      This is a sandbox conversation. Messages here are just for testing and won&apos;t be saved or shown to real
      visitors.
    </p>
  );
}
